import { FilenameTemplateItem } from '../../..'
import { DailyInspectionShortName } from '../../filenameTemplateItems/instances/dailyInspection'
import {
  projects,
  workTypes,
} from '../../filenameTemplateItems/instances/groups'
import { DefaultFilenameTemplateItemType } from '../../filenameTemplateItems/types'
import { SimpleReportItem } from './SimpleReportItem'

export class DailyInspectionReportItem<
  Name extends string,
  ClassType extends `DailyInspection${
    | 'Inspection'
    | 'ControlPoint'
    | 'PunchList'}`,
  ClassTypeName extends string,
  Endpoint extends string,
  QueryParameter extends string,
  Label extends `${string}Id`,
  ID extends string
> extends SimpleReportItem<
  ID,
  Name,
  ClassType,
  ClassTypeName,
  Endpoint,
  QueryParameter,
  Label,
  QueryParameter,
  'globalId'
> {
  constructor({
    id,
    afterShortName,
    classType,
    classTypeName,
    endpoint,
    additionalCompatibleTemplateItems,
    name,
    label,
    queryParameter,
    sampleFilename,
  }: Pick<
    SimpleReportItem<
      ID,
      Name,
      ClassType,
      ClassTypeName,
      Endpoint,
      QueryParameter,
      Label,
      QueryParameter,
      'globalId'
    >,
    | 'id'
    | 'classType'
    | 'classTypeName'
    | 'endpoint'
    | 'label'
    | 'name'
    | 'queryParameter'
    | 'sampleFilename'
  > & {
    /**
     * {@link DefaultFilenameTemplateItemType}
     * @see {@link DailyInspectionShortName}
     */
    afterShortName: DefaultFilenameTemplateItemType[]
    /**
     * @see {@link projects}
     * @see {@link workTypes}
     */
    additionalCompatibleTemplateItems: FilenameTemplateItem[]
  }) {
    super({
      afterClientProjectNumber: [
        { type: 'custom', text: '_' },
        { type: 'templateItem', templateItemId: DailyInspectionShortName.id },
        ...afterShortName,
      ],
      key: 'globalId',
      classType,
      id,
      classTypeName,
      endpoint,
      compatibleTemplateItems: [
        ...projects,
        ...workTypes,
        ...additionalCompatibleTemplateItems,
      ],
      label,
      name,
      queryParameter,
      sampleFilename,
    })
  }
}
